import ListEditable from './ListEditable'

export default ListEditable
